import type { HandleType } from '../types/registry';

export const HANDLE_COLORS: Record<HandleType, string> = {
  number: '#3b82f6',
  string: '#22c55e',
  boolean: '#a855f7',
  object: '#f97316',
  array: '#06b6d4',
  any: '#9ca3af'
};

export function getHandleColor( type: HandleType ): string {
  return HANDLE_COLORS[type] || HANDLE_COLORS.any;
}

export function getHandleFillColor( type: HandleType ): string {
  const hex = getHandleColor( type );
  // 80% opacity = CC in hex alpha
  return `${hex}CC`;
}
